var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillTrayFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5H8C6.375 5 5.3125 5.875 5 7.5L3 17V24C3.00231 24.7949 3.31912 25.5567 3.88123 26.1188C4.44334 26.6809 5.20506 26.9977 6 27H26C26.7949 26.9977 27.5567 26.6809 28.1188 26.1188C28.6809 25.5567 28.9977 24.7949 29 24V17L27 7.5C26.6875 5.8125 25.5625 5 24 5Z",
    stroke: "#FF5B00",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13H24M3 17H12H3ZM20 17H29H20ZM12 17C12 18.0609 12.4214 19.0783 13.1716 19.8284C13.9217 20.5786 14.9391 21 16 21C17.0609 21 18.0783 20.5786 18.8284 19.8284C19.5786 19.0783 20 18.0609 20 17H12ZM9 9H23H9Z",
    stroke: "#FF5B00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillTrayFull);
export default __webpack_public_path__ + "static/media/fillTrayFull.9acd7cd1f401e500ff5ab4c2dc28fe46.svg";
export { ForwardRef as ReactComponent };